import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { updateSiteConfiguration } from 'actions/Site'
import {
  createUltraVoucherCategory,
  fetchDetailUltraVoucherCategory,
  updateUltraVoucherCategory,
} from 'actions/UltraVoucherCategories'
import { message } from 'antd'
import FormUltraVoucherCategoryView from 'components/pages/ultraVouchers/categories/Form'
import Helper from 'utils/Helper'
import history from 'utils/history'
import { pickBy, identity } from 'lodash'

export function mapStateToProps(state) {
  const {
    isFecthing,
    detailUltraVoucherCategory,
    metaDetailUltraVoucherCategory,
  } = state.root.ultraVoucherCategory

  return {
    isFecthing,
    detailUltraVoucherCategory,
    metaDetailUltraVoucherCategory,
  }
}

const mapDispatchToProps = dispatch => ({
  updateSiteConfiguration: bindActionCreators(updateSiteConfiguration, dispatch),
  fetchDetailUltraVoucherCategory: bindActionCreators(fetchDetailUltraVoucherCategory, dispatch),
  createUltraVoucherCategory: bindActionCreators(createUltraVoucherCategory, dispatch),
  updateUltraVoucherCategory: bindActionCreators(updateUltraVoucherCategory, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isEdit', 'setIsEdit', false),
  withState('isSubmit', 'setIsSubmit', false),
  withState('loadStatus', 'setLoadStatus', false),
  withState('iconFile', 'setIconFile', ''),
  withHandlers({
    handleUpload: props => (info) => {
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      if (fileList.length > 0) {
        return Helper.getBase64(info.file, file => props.setIconFile(file))
      }
      return false
    },
    handleSubmit: props => (values) => {
      props.setIsSubmit(true)
      const formData = new FormData()
      Object.keys(pickBy(values, identity)).map((item) => {
        if (item === 'image' && values[item]) {
          return formData.append(item, values[item].file)
        }
        return formData.append(item, values[item])
      })
      if (props.match.params.id) {
        props.updateUltraVoucherCategory(formData, props.match.params.id).then(() => {
          history.push('/ultra-vouchers/categories')
        }).catch((err) => {
          message.error(err)
          props.setIsSubmit(false)
        })
      } else {
        props.createUltraVoucherCategory(formData).then(() => {
          history.push('/ultra-vouchers/categories')
        }).catch((err) => {
          message.error(err)
          props.setIsSubmit(false)
        })
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      const {
        match, setIsEdit, detailUltraVoucherCategory, setIconFile,
      } = this.props
      this.props.updateSiteConfiguration('breadList', ['Home', 'Ultra Voucher', 'Categories', 'Form'])
      this.props.updateSiteConfiguration('titlePage', 'Ultra Voucher - Categories Form')

      if (match.params.id) {
        this.props.fetchDetailUltraVoucherCategory(match.params.id).then(() => {
          if (detailUltraVoucherCategory) {
            setIconFile(detailUltraVoucherCategory.image)
          }
        }).catch((err) => {
          message.error(err)
        })
        setIsEdit(true)
      }
    },
  }),
)(FormUltraVoucherCategoryView)
